import React from 'react';
import './AdminMenuTypeSelector.css';

interface AdminMenuTypeSelectorProps {
  selectedType: 'med' | 'rec' | null;
  onSelectType: (type: 'med' | 'rec') => void;
  storeName?: string;
}

const AdminMenuTypeSelector: React.FC<AdminMenuTypeSelectorProps> = ({
  selectedType,
  onSelectType,
  storeName
}) => {
  return (
    <div className="admin-menu-type-selector">
      <div className="menu-type-prompt">
        {storeName && (
          <div className="menu-type-store-name">{storeName}</div>
        )}
        <h2 className="menu-type-heading">SELECT MENU TYPE</h2>
        <p className="menu-type-subtext">Choose Medical or Recreational to continue</p>
      </div>

      <div className="menu-type-buttons">
        <button
          className={`menu-type-btn ${selectedType === 'med' ? 'active' : ''}`}
          onClick={() => onSelectType('med')}
        >
          MED
        </button>
        <button
          className={`menu-type-btn ${selectedType === 'rec' ? 'active' : ''}`}
          onClick={() => onSelectType('rec')}
        >
          REC
        </button>
      </div>
    </div>
  );
};

export default AdminMenuTypeSelector;
